import { ContactType } from '../../../contacts/types/contactType'
import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import { InvoiceStatus } from '../../enums/invoiceStatus'
import { QuoteStatus } from '../../enums/quoteStatus'
import { ZervantContactType } from '../../enums/zervantContactType'
import { isDocumentTypeCreditNote } from '../isDocumentTypeCreditNote'
import { isDocumentTypeInvoice } from '../isDocumentTypeInvoice'
import { isEligibleEInvoiceStatus } from './isEligibleEInvoiceStatus'

const nonEligibleCountries = ['DK', 'FR']

interface IsDocumentEligibleForEInvoiceOptions {
  contactCountry?: string | null
  contactType?: ZervantContactType | ContactType
  documentStatus?: InvoiceStatus | QuoteStatus
  documentType: InvoiceDocumentType
  isOrganizationFrench?: boolean
  isCustomerPublicEntity?: boolean
}

export const isDocumentEligibleForEInvoice = ({
  contactCountry,
  contactType,
  documentStatus,
  documentType,
  isOrganizationFrench,
  isCustomerPublicEntity,
}: IsDocumentEligibleForEInvoiceOptions): boolean => {
  const isCompanyContact = contactType === ZervantContactType.Company || contactType === ContactType.Company
  const isEligibleDocumentType = isDocumentTypeInvoice(documentType) || isDocumentTypeCreditNote(documentType)
  const isEligibleDocumentStatus = isEligibleDocumentType && isEligibleEInvoiceStatus(documentStatus, documentType)

  if (isOrganizationFrench) {
    return isCompanyContact && !isCustomerPublicEntity && contactCountry === 'FR' && isEligibleDocumentStatus
  }

  const isEligibleCountry = !!contactCountry && !nonEligibleCountries.includes(contactCountry)

  return isEligibleDocumentStatus && isEligibleCountry && isCompanyContact
}
